import { LoaderFunctionArgs, redirect } from "react-router";

export default async function networkLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams) return redirect("/network/contacts");
  return routeParams;
}
